import React, { useState, useEffect, useRef } from 'react';
import { LoadingButton } from '@mui/lab';
import { TextField } from '@mui/material';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { getFileExtensionFromUrl } from 'app/utils/helpers.js';
import * as XLSX from '../../../../node_modules/xlsx';
import HtmlTableViewer from 'app/components/HtmlTableViewer';
import 'app/asset/css/pages-viewer.css';
import 'app/asset/libs/fontawesome-free/css/all.min.css';

const initialValues = {
  password: '',
};

const PageViewer = () => {
    const [loading, setLoading] = useState(false);
    const [document, setDocument] = useState("");
    const urlSearchParams = new URLSearchParams(window.location.search);
    const secret_key = urlSearchParams.get('secret_key');
    const uri_segment = window.atob(secret_key);
    const segment = uri_segment.split('/');

    const fileExtension = getFileExtensionFromUrl(uri_segment);
    const allowExcels = ["xlsx", "xls", "csv"];
    const allowDocs = ["docx", "doc"];
    const allowPpts = ["pptx", "ppt"];
    const allowImages = ["png", "jpeg", "jpg"];

    const validationSchema = Yup.object().shape({
        password: Yup.string()
            .min(8, 'Document password must be 8 character length')
            .required('Document password is required!'),
    });

    const handleFormSubmit = async (values, { setFieldError }) => {
        setLoading(true);

        try {
            await validationSchema.validate(values, { abortEarly: false });
            if (values.password === segment[2]) {
                setDocument(uri_segment);
            } else {
                setFieldError("password", "Document password does not match");
            }
        } catch (error) {
            console.error("Validation Error:", error);
        } finally {
            setLoading(false);
        }
    };

    function FileViewer({url}) {
        const [fileContent, setFileContent] = useState(null);

        useEffect(() => {
        const loadFiles = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_TRANSACTIONS + "wtc-auth/"+ url + "/preview", {
                    method: 'GET'
                });

                const arrayBuffer = await response.arrayBuffer();

                if (!response.ok) {
                    console.error('Failed to fetch file:', response.statusText);
                    return;
                }

                if (allowImages.includes(fileExtension)) {
                    const blob = new Blob([arrayBuffer], { type: `image/${fileExtension}` });
                    const dataUrl = URL.createObjectURL(blob);

                    setFileContent(<img src={dataUrl} alt="Preview" />);
                } else if (fileExtension === "pdf") {
                    const blob = new Blob([arrayBuffer], { type: "application/pdf" });
                    const dataUrl = URL.createObjectURL(blob);

                    setFileContent(<iframe  src={dataUrl+"#toolbar=0"} width="100%" height="600" title="PDF Viewer"></iframe>);
                } else if (allowExcels.includes(fileExtension)) {
                    const workbook = XLSX.read(arrayBuffer);
                    const worksheet = workbook.Sheets[workbook.SheetNames[0]];

                    const data = XLSX.utils.sheet_to_json(worksheet, { header: 1, blankrows: true });

                    setFileContent(<HtmlTableViewer arrayBuffer={arrayBuffer} />);
                } else if (allowDocs.includes(fileExtension) || allowPpts.includes(fileExtension)) {
                    try {
                    const textDecoder = new TextDecoder('utf-8');
                    const binaryData = textDecoder.decode(arrayBuffer);

                    function stringToArrayBuffer(str) {
                        const buffer = new ArrayBuffer(str.length);
                        const view = new Uint8Array(buffer);
                        for (let i = 0; i < str.length; i++) {
                        view[i] = str.charCodeAt(i);
                        }
                        return buffer;
                    }
                    
                    function arrayBufferToBase64(buffer) {
                        const bytes = new Uint8Array(buffer);
                        let binary = '';
                        for (let i = 0; i < bytes.byteLength; i++) {
                        binary += String.fromCharCode(bytes[i]);
                        }
                        return btoa(binary);
                    }

                    const base64Data = arrayBufferToBase64(stringToArrayBuffer(binaryData));

                    setFileContent(<iframe src={`data:application/pdf;base64,${base64Data}`} width="100%" height="600" title="PDF Viewer"></iframe>);
                    } catch (error) {
                    console.error('Error:', error.message);
                    }
                } else {
                    console.error('Unsupported file type !');
                }
            } catch (error) {
                console.error('Error fetching file:', error.message);
            }
        };

        loadFiles();
        }, [url]);

        return <div>{fileContent}</div>;
    }


    return (
        <>
            <div className="container">
                <div className={ document == "" ? "card card-lock" : "card card-viewer"}>
                    <div className="card-body">
                        {
                            document == "" ?
                                <>
                                    <div className="form-group row">
                                        <div className="text-center">
                                            <div className='row'>
                                                <i className='fa fa-lock'></i>
                                            </div>
                                            <div className='row'>
                                                <span className='text-locked'> -- DOCUMENT LOCKED -- </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row mt-3 mb-1">
                                        <Formik
                                            onSubmit={handleFormSubmit}
                                            initialValues={initialValues}
                                            validationSchema={validationSchema}
                                        >
                                            {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                                            <form className='form-horizontal' onSubmit={handleSubmit}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    name="password"
                                                    type="password"
                                                    label="Document password"
                                                    variant="outlined"
                                                    onBlur={handleBlur}
                                                    value={values.password}
                                                    autoFocus={true}
                                                    onChange={handleChange}
                                                    helperText={touched.password && errors.password}
                                                    error={Boolean(errors.password && touched.password)}
                                                />
                                                <LoadingButton
                                                    type="submit"
                                                    color="primary"
                                                    loading={loading}
                                                    variant="contained"
                                                    size='large'
                                                    fullWidth
                                                    sx={{ borderRadius : "5px" }}
                                                >
                                                Unlock Document !
                                                </LoadingButton>
                                            </form>
                                            )}
                                        </Formik>
                                    </div>
                                </>
                            : 
                             <FileViewer url={document} />
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default PageViewer;